import { APPLICATIONS, getApplicationAccessLink } from '~/components/ApplicationUrls';

const URL_TYPES = {
  PROGRAM: 'PROGRAM',
  SETTINGS: 'SETTINGS',
  ANALYTICS: 'ANALYTICS',
};

const SERIES_LINKS = {
  ADMIN: {
    [URL_TYPES.PROGRAM]: (seriesId: string) => `/new/ui/admin/program/${seriesId}/modules`,
    [URL_TYPES.SETTINGS]: (seriesId: string) => `/new/ui/admin/program/${seriesId}/settings`,
    [URL_TYPES.ANALYTICS]: (seriesId: string) =>
      `${getApplicationAccessLink(APPLICATIONS.ANALYTICS)}/series/${seriesId}/overview`,
  },
  LEARNER: {},
};

function getSeriesAccessLinkGenerator(forAdmin: boolean = true) {
  return forAdmin ? SERIES_LINKS.ADMIN : SERIES_LINKS.LEARNER;
}

export default getSeriesAccessLinkGenerator;

export { URL_TYPES, SERIES_LINKS };
